/**
 * @fileOverview
 * Demo Application
 */
import React from 'react';
import { HashRouter as ReactRouter } from 'react-router-dom';
import { setupFDS } from '@tcc/fds';
import { AppRouter } from './router/AppRouter/AppRouter';
import './utils/datadog';
import { renderUsingContextVersion } from './utils/renderUsingContextVersion';

declare global {
  interface Window {
    timerStart: number;
    timeEvents: {
      fieldView: {
        appStart: number;
      };
    };
  }
}

window.timerStart = Date.now();
setupFDS();

const App = () =>
  (
    <ReactRouter>
      <AppRouter />
    </ReactRouter>
  );

renderUsingContextVersion(<App />, document.getElementById('root'));
